import { styled } from '@mui/material/styles';
import { StyledInput } from 'components/form/TextInput';
import useComponentWillReceiveProps from 'hooks/useComponentWillReceiveProps';
import React, { useMemo, useEffect, useRef } from 'react';

const Input = styled(StyledInput)({
  display: 'block',
});

const TextFilter = (props) => {
  const { onChange, defaultValue, dataField, onApplyFilters, ...other } = props;
  const timer = useRef();
  const defaultSet = useRef(false);

  useComponentWillReceiveProps(props, (nextProps, prevProps) => {
    if (
      nextProps.defaultValue !== prevProps.defaultValue &&
      nextProps.defaultValue
    ) {
      onChange(dataField, nextProps.defaultValue);
      onApplyFilters();
    }
  });

  useEffect(() => {
    if (defaultValue) {
      onChange(dataField, defaultValue);
      defaultSet.current = true;
    }
    return () => timer.current && clearTimeout(timer.current);
  }, []);

  const handleChange = (e) => {
    const { target } = e;
    onChange(dataField, target.value);
    if (props.trigger !== 'enter') {
      clearTimeout(timer.current);
      timer.current = setTimeout(onApplyFilters, 500);
    }
  };

  const onKeyPress = (e) => {
    if (e.key === 'Enter' && props.trigger === 'enter') {
      onApplyFilters();
    }
  };

  return (
    <>
      <Input
        margin="none"
        size="small"
        sx={{
          '& input': {
            borderRadius: '6px !important',
            padding: '4px 6px',
          },
        }}
        {...other}
        onChange={handleChange}
        onKeyPress={onKeyPress}
      />
    </>
  );
};

export default TextFilter;
